const data = {
    type: 'Topology',
    arcs: [
        [
            [1482, 5467],
            [117, 17],
        ],
        [
            [1599, 5484],
            [18, -28],
            [32, -19],
            [-17, -26],
            [45, -37],
            [-24, -33],
            [36, -29],
            [38, -18],
            [2, -73],
        ],
        [
            [1729, 5221],
            [-31, -4],
        ],
        [
            [1698, 5217],
            [-34, 62],
            [0, 16],
            [-37, 0],
            [-25, 29],
            [-18, -3],
        ],
        [
            [1584, 5321],
            [-33, 31],
            [-63, 26],
            [8, 52],
            [-14, 37],
        ],
        [
            [1698, 5217],
            [-58, 15],
            [-43, 49],
            [-13, 40],
        ],
        [
            [1599, 5484],
            [21, 17],
            [63, -30],
            [45, -7],
            [12, 13],
            [-42, 57],
            [22, 15],
        ],
        [
            [1720, 5549],
            [24, -4],
            [58, -64],
            [37, -7],
            [15, 27],
            [50, 42],
            [45, -56],
            [43, -75],
            [39, -5],
            [26, -29],
            [-70, -8],
            [-14, -83],
            [-15, -37],
            [-31, -25],
            [2, -52],
        ],
        [
            [1929, 5173],
            [-21, -6],
            [-52, 56],
            [29, 53],
            [-25, 31],
            [-32, -8],
            [-99, -78],
        ],
        [
            [2971, 4889],
            [86, -40],
            [64, 14],
            [17, 48],
            [67, 16],
            [48, 32],
            [16, 85],
            [72, 21],
            [13, 38],
            [40, -29],
            [25, -3],
        ],
        [
            [3419, 5071],
            [47, -1],
            [64, -22],
        ],
        [
            [3530, 5048],
            [26, -13],
            [61, 34],
            [28, -21],
            [28, 49],
            [50, -2],
            [13, 16],
            [9, 42],
            [36, 37],
            [46, -24],
            [-9, -32],
            [26, -5],
            [-8, -90],
            [33, -34],
            [30, 22],
            [37, 10],
            [53, 48],
            [58, -8],
            [87, 0],
        ],
        [
            [4134, 5077],
            [15, -30],
        ],
        [
            [4149, 5047],
            [-49, -12],
            [-43, -20],
            [-97, -12],
            [-91, -23],
            [-49, -46],
            [20, -45],
            [10, -53],
            [-42, -44],
            [3, -41],
            [-23, -39],
            [-81, 4],
            [34, -71],
            [-54, -26],
            [-36, -65],
            [5, -63],
            [-33, -30],
            [-32, 10],
            [-64, -14],
            [-9, -30],
            [-63, 0],
            [-47, -60],
            [-3, -90],
            [-110, -44],
            [-59, 9],
            [-17, -23],
            [-51, 13],
            [-84, -16],
            [-142, 54],
        ],
        [
            [2942, 4270],
            [77, 97],
            [-7, 68],
            [-64, 18],
            [-6, 68],
            [-28, 84],
            [36, 59],
            [-37, 15],
            [23, 78],
            [35, 132],
        ],
        [
            [2157, 3677],
            [15, 5],
            [3, -29],
            [66, 17],
            [70, -3],
            [51, -3],
            [58, 72],
            [63, 68],
            [54, 65],
        ],
        [
            [2537, 3869],
            [16, -36],
        ],
        [
            [2553, 3833],
            [11, -84],
        ],
        [
            [2564, 3749],
            [-43, 0],
            [-7, -69],
            [15, -15],
            [-38, -21],
            [0, -43],
            [-25, -44],
            [-2, -43],
        ],
        [
            [2464, 3514],
            [-17, -23],
            [-254, 54],
            [-33, 108],
            [-3, 24],
        ],
        [
            [7121, 3086],
            [-73, -51],
            [-69, 32],
            [-3, 92],
            [42, 48],
            [92, 30],
            [49, -3],
            [19, -40],
            [-37, -47],
            [-20, -61],
        ],
        [
            [4134, 5077],
            [-13, 61],
            [3, 41],
            [-51, 24],
            [-28, -11],
            [-21, 99],
        ],
        [
            [4024, 5291],
            [24, 24],
            [-12, 25],
            [81, 50],
            [58, 21],
            [90, -14],
            [32, 68],
            [108, 12],
            [30, 42],
            [133, 58],
            [12, 24],
        ],
        [
            [4580, 5601],
            [-7, 60],
            [58, 28],
            [-76, 185],
            [168, 42],
            [43, 24],
            [61, 190],
            [167, -35],
            [47, 48],
            [4, 107],
            [71, 10],
            [64, 70],
        ],
        [
            [5180, 6330],
            [33, 9],
        ],
        [
            [5213, 6339],
            [22, -74],
            [71, -56],
            [121, -40],
            [58, -86],
            [-33, -124],
            [31, -46],
            [100, -18],
            [114, -15],
            [102, -66],
            [52, -12],
            [39, -98],
            [49, -63],
            [93, 2],
            [175, -24],
            [112, 15],
            [83, -16],
            [125, -64],
            [103, 0],
            [37, -33],
            [98, 57],
            [137, 37],
            [127, 4],
            [98, 37],
            [61, 57],
            [59, 36],
            [-14, 35],
            [-27, 41],
            [45, 68],
            [47, -9],
            [87, -22],
            [84, 57],
            [129, 41],
            [62, 70],
            [59, 30],
            [123, 14],
            [67, -12],
            [9, 38],
            [-77, 74],
            [-67, 34],
            [-65, -39],
            [-84, 17],
            [-47, -14],
            [-22, 44],
            [59, 106],
            [42, 80],
        ],
        [
            [7657, 6402],
            [101, -40],
            [119, 67],
            [-1, 47],
            [77, 112],
            [47, 34],
            [-1, 59],
            [-47, 25],
            [70, 53],
            [105, 19],
            [112, 3],
            [126, -31],
            [75, -39],
            [52, -108],
            [31, -45],
            [30, -66],
            [31, -104],
            [147, -34],
            [100, -75],
            [34, -100],
            [129, 0],
            [73, 42],
            [140, 31],
            [-45, -96],
            [-33, -38],
            [-29, -117],
            [-56, -103],
            [-103, 19],
            [-72, -38],
            [22, -91],
            [-12, -125],
            [-43, -3],
            [0, -54],
        ],
        [
            [8836, 5606],
            [-55, 62],
            [-33, -59],
            [-131, -46],
            [14, -56],
            [-73, 4],
            [-41, 33],
            [-58, -75],
            [-93, -57],
            [-68, -68],
        ],
        [
            [8298, 5344],
            [-119, -31],
            [-62, -50],
            [-91, -29],
            [45, 49],
            [-18, 42],
            [67, 71],
            [-44, 56],
            [-74, -38],
            [-95, -74],
            [-52, -68],
            [-83, -5],
            [-43, -50],
            [44, -72],
            [69, -17],
            [3, -48],
            [67, -31],
            [95, 76],
            [75, -41],
            [54, -3],
            [14, -56],
            [-120, -30],
            [-39, -57],
            [-82, -53],
            [-44, -75],
            [91, -58],
            [34, -105],
            [51, -97],
            [57, -82],
            [-1, -79],
            [-53, -29],
            [20, -56],
            [50, -33],
            [-13, -87],
            [-22, -84],
            [-47, -10],
            [-61, -115],
            [-69, -139],
            [-78, -127],
            [-116, -98],
            [-118, -89],
            [-95, -12],
            [-52, -48],
            [-29, 35],
            [-48, -53],
            [-118, -53],
            [-89, -17],
            [-29, -112],
            [-47, -6],
            [-22, 77],
            [20, 41],
            [-113, 34],
            [-40, -17],
        ],
        [
            [6928, 3391],
            [-85, 28],
            [-41, 43],
            [14, 61],
            [-77, 19],
            [-41, 40],
            [-72, -56],
            [-82, -13],
            [-68, 1],
            [-45, -26],
        ],
        [
            [6431, 3488],
            [-44, -16],
            [13, -121],
            [-45, 3],
            [-8, 25],
        ],
        [
            [6347, 3379],
            [-2, 44],
            [-62, -31],
            [-37, 19],
            [-62, 40],
            [24, 88],
            [-53, 21],
            [-21, 98],
            [-89, -18],
            [10, 126],
            [80, 89],
            [4, 88],
            [-3, 81],
            [-37, 25],
            [-28, 63],
            [-49, -8],
        ],
        [
            [6022, 4104],
            [-91, 16],
            [28, 44],
            [-39, 66],
            [-61, -44],
            [-70, 26],
            [-98, -68],
            [-77, -79],
            [-68, -13],
        ],
        [
            [5546, 4052],
            [-37, 28],
            [-44, 3],
            [-61, 25],
            [-45, -27],
            [-56, -79],
        ],
        [
            [5303, 4002],
            [-7, 83],
            [-52, -22],
        ],
        [
            [5244, 4063],
            [-98, 10],
            [-96, 25],
            [-69, 46],
            [-65, 21],
            [-29, 51],
            [-47, 16],
            [-85, 69],
            [-68, 33],
            [-35, -26],
        ],
        [
            [4652, 4308],
            [-117, 74],
            [-83, 68],
            [-24, 117],
            [61, -14],
            [2, 54],
            [-33, 54],
            [8, 87],
            [-91, 124],
        ],
        [
            [4375, 4872],
            [-139, 43],
            [-25, 82],
            [-62, 50],
        ],
        [
            [5629, 3443],
            [-2, -76],
            [-30, 16],
            [6, -86],
        ],
        [
            [5603, 3297],
            [-24, 56],
            [-5, 54],
            [-16, 51],
            [-35, 62],
            [-78, 4],
            [7, -44],
            [-26, -59],
            [-36, 22],
            [-12, -20],
            [-24, 12],
            [-33, 9],
        ],
        [
            [5321, 3444],
            [-13, 88],
            [-29, 80],
            [14, 64],
            [-52, 28],
            [19, 39],
            [53, 40],
            [-61, 56],
            [29, 72],
            [67, -46],
            [41, -5],
            [7, -74],
            [81, -15],
            [78, 2],
            [49, -18],
            [-39, -90],
            [-38, -6],
            [-26, -61],
            [46, -55],
            [14, 68],
            [23, 0],
            [45, -168],
        ],
        [
            [7448, 1582],
            [33, 40],
            [72, 58],
        ],
        [
            [7553, 1680],
            [-4, -53],
            [-5, -67],
            [-40, 3],
            [-18, -36],
            [-38, 55],
        ],
        [
            [5546, 4052],
            [35, -34],
            [-6, -65],
            [-69, -4],
            [-72, 8],
            [-53, -17],
            [-76, 40],
            [-2, 22],
        ],
        [
            [670, 4826],
            [3, -8],
            [-87, -44],
            [-41, 14],
            [-20, 43],
            [40, 4],
        ],
        [
            [565, 4835],
            [16, -6],
            [23, 9],
            [16, -1],
            [6, -6],
            [2, -11],
            [4, 4],
            [13, -2],
            [16, 8],
            [9, -4],
        ],
        [
            [565, 4835],
            [6, 0],
            [12, 26],
            [61, -1],
            [77, 31],
            [-57, -45],
            [6, -20],
        ],
        [
            [1482, 5467],
            [-82, 52],
            [-90, -5],
        ],
        [
            [1310, 5514],
            [13, 46],
            [-21, 72],
            [-49, 39],
            [-47, 13],
            [-31, 32],
            [11, 13],
            [71, -18],
            [124, -18],
            [115, -51],
            [15, -19],
            [51, 16],
            [79, -22],
            [26, -43],
            [53, -25],
        ],
        [
            [7998, 13],
            [-36, -2],
            [-112, 74],
            [79, 21],
            [44, -32],
            [30, -33],
            [-5, -28],
        ],
        [
            [8357, 156],
            [8, -21],
            [2, -32],
        ],
        [
            [8367, 103],
            [-55, -80],
            [-72, -23],
            [-11, 13],
            [8, 36],
            [36, 65],
            [84, 42],
        ],
        [
            [7760, 241],
            [30, -29],
            [52, 9],
            [21, -45],
            [-97, -22],
            [-59, -14],
            [-45, 1],
            [29, 61],
            [46, 1],
            [23, 38],
        ],
        [
            [8182, 241],
            [-12, -59],
            [-127, -30],
            [-112, 13],
            [0, 38],
            [67, 23],
            [53, -32],
            [56, 8],
            [75, 39],
        ],
        [
            [6976, 381],
            [162, -11],
            [19, 44],
            [156, -51],
            [31, -69],
            [127, -19],
            [103, -64],
            [-96, -40],
            [-93, 43],
            [-76, -3],
            [-88, 8],
            [-79, 19],
            [-98, 40],
            [-62, 11],
            [-35, -13],
            [-154, 43],
            [-15, 46],
            [-77, 8],
            [58, 101],
            [102, -6],
            [69, -41],
            [35, -9],
            [11, -37],
        ],
        [
            [9181, 441],
            [-43, -73],
            [-9, 80],
            [15, 38],
            [18, 36],
            [19, -31],
            [0, -50],
        ],
        [
            [8550, 733],
            [-32, -35],
            [-58, 20],
            [-17, 45],
            [86, 5],
            [21, -35],
        ],
        [
            [8822, 772],
            [30, -81],
            [-71, 44],
            [-70, 9],
            [-48, -7],
            [-59, 3],
            [20, 59],
            [105, 4],
            [93, -31],
        ],
        [
            [9132, 978],
            [24, -171],
            [87, -64],
            [71, 113],
            [97, 64],
            [75, 0],
            [72, -37],
            [63, -38],
            [90, -20],
            [2, -347],
            [1, -346],
            [-75, 87],
            [-86, 22],
            [-21, -31],
            [-107, -3],
            [36, 86],
            [53, 30],
            [-22, 116],
            [-40, 89],
            [-164, 90],
            [-70, 9],
            [-127, 98],
            [-25, -52],
            [-32, -9],
            [-19, 39],
            [0, 46],
            [-65, 52],
            [91, 38],
            [60, -2],
            [-7, 29],
            [-123, 0],
            [-34, 63],
            [-75, 20],
            [-36, 52],
            [114, 26],
            [43, 35],
            [136, -44],
            [13, -40],
        ],
        [
            [8380, 1252],
            [-68, -106],
            [-63, -20],
            [-82, 21],
            [-141, -6],
            [-73, -15],
            [-12, -80],
            [75, -95],
            [46, 48],
            [157, 36],
            [-7, -49],
            [-36, 16],
            [-37, -62],
            [-74, -42],
            [80, -136],
            [-16, -36],
            [76, -123],
            [-1, -70],
            [-45, -31],
            [-33, 37],
            [41, 87],
            [-83, -41],
            [-21, 30],
            [11, 41],
            [-61, 62],
            [6, 104],
            [-56, -33],
            [7, -124],
            [4, -152],
            [-54, -15],
            [-36, 31],
            [24, 98],
            [-13, 103],
            [-36, 0],
            [-26, 73],
            [35, 70],
            [12, 84],
            [42, 160],
            [18, 44],
            [72, 79],
            [66, -31],
            [107, -15],
            [97, 4],
            [83, 77],
            [15, -23],
        ],
        [
            [8671, 1221],
            [-4, -93],
            [-44, 11],
            [-13, -65],
            [35, -56],
            [-24, -13],
            [-34, 68],
            [-25, 135],
            [17, 85],
            [28, 39],
            [6, -58],
            [50, -9],
            [8, -44],
        ],
        [
            [7064, 1314],
            [14, -71],
            [58, -60],
            [54, 22],
            [54, -8],
            [49, 54],
            [41, 9],
            [80, -30],
            [69, 23],
            [43, 148],
            [33, 37],
            [29, 120],
            [97, 0],
            [73, -18],
        ],
        [
            [7758, 1540],
            [-48, -95],
            [62, -101],
            [-14, -49],
            [94, -98],
            [-100, -13],
            [-28, -72],
            [4, -97],
            [-81, -72],
            [-3, -106],
            [-32, -163],
            [-13, 38],
            [-96, -48],
            [-33, 65],
            [-60, 6],
            [-42, 34],
            [-101, -38],
            [-31, 52],
            [-55, -6],
            [-70, 12],
            [-13, 143],
            [-42, 29],
            [-40, 91],
            [-12, 93],
            [10, 98],
            [50, 71],
        ],
        [
            [6739, 479],
            [-93, -2],
            [-72, 89],
            [-108, 86],
            [-36, 65],
            [-64, 86],
            [-42, 80],
            [-64, 149],
            [-75, 88],
            [-24, 92],
            [-32, 83],
            [-76, 67],
            [-44, 90],
            [-63, 60],
            [-89, 117],
            [-7, 54],
            [54, -4],
            [131, -21],
            [75, -104],
            [65, -72],
            [47, -44],
            [80, -114],
            [86, -2],
            [71, -73],
            [49, -89],
            [64, -48],
            [-34, -87],
            [48, -37],
            [31, -2],
            [14, -75],
            [30, -59],
            [62, -9],
            [41, -68],
            [-22, -132],
            [-3, -164],
        ],
        [
            [6022, 4104],
            [6, -40],
            [-29, -20],
            [7, -65],
            [-61, 19],
            [-109, -73],
            [2, -61],
            [-46, -89],
            [-5, -52],
            [-37, -88],
            [-66, 24],
            [-4, -110],
            [-19, -36],
            [9, -45],
            [-41, -25],
        ],
        [
            [5321, 3444],
            [-12, -38],
            [-57, 1],
            [-105, -22],
            [5, -80],
            [-45, -63],
            [-121, -71],
            [-95, -125],
            [-63, -67],
            [-85, -70],
            [0, -49],
            [-42, -26],
            [-76, -38],
            [-39, -6],
            [-26, -81],
            [18, -138],
            [4, -88],
            [-36, -101],
            [0, -181],
            [-44, -5],
            [-38, -81],
            [26, -35],
            [-77, -30],
            [-29, -72],
            [-34, -31],
            [-80, 99],
            [-39, 149],
            [-32, 107],
            [-30, 51],
            [-45, 102],
            [-21, 133],
            [-14, 66],
            [-77, 146],
            [-35, 206],
            [-25, 136],
            [0, 129],
            [-16, 99],
            [-123, -64],
            [-60, 13],
            [-110, 129],
            [40, 38],
            [-25, 42],
            [-99, 90],
        ],
        [
            [3559, 3618],
            [57, 71],
            [185, 0],
            [-16, 91],
            [-48, 54],
            [-9, 82],
            [-56, 48],
            [93, 111],
            [99, -8],
            [88, 111],
            [53, 108],
            [82, 107],
            [-1, 75],
            [72, 62],
            [-69, 52],
            [-29, 72],
            [-30, 93],
            [42, 46],
            [128, -26],
            [94, 16],
            [81, 89],
        ],
        [
            [4652, 4308],
            [-54, -48],
            [-32, -100],
            [81, -40],
            [80, -52],
            [110, -59],
            [116, -14],
            [49, -54],
            [65, -10],
            [102, -25],
            [70, 2],
            [10, 42],
            [-11, 67],
            [6, 46],
        ],
        [
            [1637, 4924],
            [55, -32],
            [7, -62],
            [-43, -37],
            [-19, -83],
            [58, -101],
            [104, -58],
            [43, -81],
            [-14, -77],
            [27, 0],
            [1, -56],
            [47, -56],
        ],
        [
            [1903, 4281],
            [-50, 5],
        ],
        [
            [1853, 4286],
            [-57, 9],
            [-62, -102],
        ],
        [
            [1734, 4193],
            [-157, 8],
            [-238, 214],
            [-126, 74],
            [-102, 29],
        ],
        [
            [1111, 4518],
            [-34, 130],
        ],
        [
            [1077, 4648],
            [187, 110],
            [32, 129],
            [-8, 77],
            [46, 27],
            [44, 66],
        ],
        [
            [1378, 5057],
            [36, 16],
            [98, -13],
            [30, -27],
            [40, 18],
        ],
        [
            [1582, 5051],
            [55, -127],
        ],
        [
            [817, 4576],
            [-14, -33],
        ],
        [
            [803, 4543],
            [-31, 15],
            [-18, -71],
            [22, -12],
            [-22, -15],
            [-4, -28],
            [40, 15],
        ],
        [
            [790, 4447],
            [2, -42],
            [-42, -169],
        ],
        [
            [750, 4236],
            [-55, 182],
            [24, 35],
            [-6, 6],
            [23, 50],
            [17, 80],
            [12, 27],
            [2, 1],
        ],
        [
            [767, 4617],
            [29, 0],
            [7, 18],
            [23, 2],
        ],
        [
            [826, 4637],
            [1, -44],
            [-11, -16],
            [1, -1],
        ],
        [
            [1929, 5173],
            [27, -79],
            [80, -22],
            [59, -53],
            [120, -18],
            [132, 28],
            [8, 25],
        ],
        [
            [2355, 5054],
            [74, 20],
            [60, 61],
            [57, -3],
            [37, 20],
            [60, -10],
            [93, -54],
            [68, -12],
            [96, -94],
            [63, -4],
            [8, -89],
        ],
        [
            [2942, 4270],
            [42, -55],
            [34, -65],
            [81, -46],
            [2, -94],
            [41, -17],
            [7, -49],
            [-122, -55],
            [-32, -123],
        ],
        [
            [2995, 3766],
            [-159, 32],
            [-92, 24],
            [-95, 14],
            [-36, 130],
            [-41, 19],
            [-65, -19],
            [-85, -51],
            [-103, 35],
            [-85, 82],
            [-82, 30],
            [-56, 101],
            [-62, 141],
            [-46, -17],
            [-54, 35],
            [-31, -41],
        ],
        [
            [1582, 5051],
            [0, 0],
            [-46, 85],
            [17, 33],
            [-27, 121],
            [58, 31],
        ],
        [
            [9174, 4729],
            [11, -36],
            [-48, -64],
            [-35, 34],
            [-43, -25],
            [-22, -62],
            [-55, 30],
            [0, 51],
            [47, 63],
            [48, -12],
            [35, 44],
            [62, -23],
        ],
        [
            [9709, 5048],
            [-32, -85],
            [15, -54],
            [-44, -74],
            [-108, -50],
            [-148, -7],
            [-121, -121],
            [-56, 41],
            [-4, 79],
            [-147, -23],
            [-100, -50],
            [-99, -3],
            [86, -78],
            [-56, -180],
            [-55, -45],
            [-41, 41],
            [21, 96],
            [-54, 31],
            [-34, 73],
            [80, 33],
            [44, 66],
            [85, 55],
            [62, 73],
            [168, 32],
            [91, -22],
            [88, 189],
            [56, -51],
            [124, 106],
            [48, 42],
            [53, 130],
            [-14, 119],
            [36, 67],
            [89, 20],
            [46, -148],
            [-2, -86],
            [-78, -107],
            [1, -109],
        ],
        [
            [9957, 5795],
            [59, -23],
            [60, 45],
            [19, -119],
            [-125, -29],
            [-74, -106],
            [-133, 73],
            [-46, -116],
            [-94, -2],
            [-12, 106],
            [42, 81],
            [90, 6],
            [25, 147],
            [25, 83],
            [99, -111],
            [65, -35],
        ],
        [
            [1111, 4518],
            [-16, -16],
            [-169, -53],
            [84, -106],
            [-28, -18],
            [-14, -36],
            [-64, -15],
            [-21, -38],
            [-36, -33],
            [-94, 17],
        ],
        [
            [753, 4220],
            [-3, 16],
        ],
        [
            [790, 4447],
            [13, 31],
            [0, 65],
        ],
        [
            [817, 4576],
            [95, -42],
            [165, 114],
        ],
        [
            [4024, 5291],
            [-160, -16],
            [-104, 34],
            [-92, -8],
            [8, 61],
            [92, -18],
            [31, 33],
        ],
        [
            [3799, 5377],
            [64, -10],
            [108, 76],
            [-100, 56],
            [-60, -26],
            [-62, 40],
            [71, 69],
            [-25, 10],
        ],
        [
            [3795, 5592],
            [19, 47],
            [55, 15],
            [139, -37],
            [13, 63],
            [48, 22],
            [121, -45],
            [30, 12],
            [140, -3],
            [126, -11],
            [42, -39],
            [52, -15],
        ],
        [
            [3795, 5592],
            [-49, -20],
            [-111, -74],
            [-37, -76],
            [-32, 0],
            [-23, 50],
            [-107, 3],
            [-17, 87],
            [-42, 1],
            [7, 107],
            [-101, 77],
            [-145, -8],
            [-99, -15],
            [-81, 95],
            [-69, 41],
            [-131, 76],
            [-16, 9],
            [-217, -63],
            [3, -392],
        ],
        [
            [2528, 5490],
            [-43, -5],
            [-59, 83],
            [-58, 30],
            [-95, -22],
            [-38, -35],
        ],
        [
            [2235, 5541],
            [-5, 26],
            [21, 44],
            [-16, 37],
            [-98, 36],
            [-38, 96],
            [-47, 26],
            [-2, 35],
            [82, -10],
            [3, 78],
            [72, 17],
            [74, -16],
            [15, 104],
            [-15, 65],
            [-85, -5],
            [-72, 26],
            [-97, -47],
            [-79, -22],
            [-43, 17],
            [9, 55],
            [-54, 71],
            [-63, -3],
            [-72, 72],
            [49, 81],
            [-25, 21],
            [68, 117],
            [87, -62],
            [10, 78],
            [175, 116],
            [132, 2],
            [186, -73],
            [100, -43],
            [89, 45],
            [134, 2],
            [108, -55],
            [25, 31],
            [119, -4],
            [21, 50],
            [-137, 73],
            [81, 52],
            [-16, 29],
            [81, 27],
            [-61, 73],
            [39, 36],
            [316, 37],
            [41, 27],
            [212, 39],
            [76, 44],
            [151, -23],
            [27, -110],
            [88, 26],
            [109, -36],
            [-7, -58],
            [81, 6],
            [211, 100],
            [-30, -33],
            [107, -82],
            [189, -270],
            [45, 55],
            [116, -61],
            [122, 27],
            [47, -19],
            [40, -61],
            [59, -21],
            [36, -45],
            [109, 14],
            [45, -65],
        ],
        [
            [6466, 2396],
            [-20, 128],
            [54, 88],
            [109, 21],
            [80, -16],
        ],
        [
            [6689, 2617],
            [69, -41],
            [38, 73],
            [75, -39],
        ],
        [
            [6871, 2610],
            [20, -71],
            [-11, -127],
            [-141, -82],
            [37, -64],
            [-89, -8],
            [-73, -43],
        ],
        [
            [6614, 2215],
            [-71, 16],
            [-34, 55],
            [-43, 110],
        ],
        [
            [1853, 4286],
            [17, -47],
            [-7, -24],
            [27, -80],
        ],
        [
            [1890, 4135],
            [-60, -3],
            [-21, 51],
            [-75, 10],
        ],
        [
            [8643, 5204],
            [72, -126],
            [21, -69],
            [1, -122],
            [-32, -58],
            [-76, -21],
            [-68, -44],
            [-76, -9],
            [-9, 58],
            [15, 80],
            [-37, 110],
            [63, 18],
            [-58, 91],
        ],
        [
            [8459, 5112],
            [5, 10],
            [38, -4],
            [33, 48],
            [59, 5],
            [36, 7],
            [13, 26],
        ],
        [
            [6431, 3488],
            [49, -84],
            [38, -97],
            [104, 0],
            [33, -93],
            [-54, -28],
            [-24, -38],
            [101, -64],
            [70, -125],
            [53, -94],
            [64, -74],
            [22, -75],
            [-16, -106],
        ],
        [
            [6689, 2617],
            [27, 48],
            [4, 90],
            [-69, 93],
            [-5, 105],
            [-64, 86],
            [-64, 7],
            [-17, -37],
            [-50, -3],
            [-25, 19],
            [-89, -63],
            [-2, 95],
            [21, 112],
            [-57, 5],
            [-5, 64],
            [-37, 32],
        ],
        [
            [6257, 3270],
            [18, 40],
            [72, 69],
        ],
        [
            [767, 4617],
            [30, 87],
            [42, 74],
            [2, 4],
        ],
        [
            [841, 4782],
            [38, -5],
            [14, -42],
            [-46, -40],
            [-21, -58],
        ],
        [
            [4709, 1900],
            [-13, -110],
            [-35, -31],
            [-73, -24],
            [-41, 85],
            [-15, 152],
            [39, 173],
            [58, -59],
            [39, -75],
            [41, -111],
        ],
        [
            [6429, 1762],
            [19, -10],
            [50, -64],
            [35, -71],
            [5, -72],
            [-9, -48],
            [8, -37],
            [7, -63],
            [29, -29],
            [33, -94],
            [-1, -36],
            [-60, -7],
            [-80, 79],
            [-100, 84],
            [-10, 54],
            [-49, 71],
            [-11, 88],
            [-31, 58],
            [10, 78],
            [-19, 45],
        ],
        [
            [6255, 1788],
            [15, 19],
            [69, -47],
            [6, -54],
            [56, 12],
            [28, 44],
        ],
        [
            [7553, 1680],
            [65, 74],
            [43, 83],
            [34, 0],
            [43, -54],
            [4, -46],
            [56, -30],
            [70, -32],
            [-6, -41],
            [-57, -5],
            [15, -52],
            [-62, -37],
        ],
        [
            [7064, 1314],
            [62, -36],
            [65, 19],
            [17, 90],
            [36, 20],
            [101, 23],
            [61, 85],
            [42, 67],
        ],
        [
            [6257, 3270],
            [-48, -24],
            [-49, -46],
            [-60, -5],
            [-38, -115],
            [-36, -19],
            [41, -93],
            [53, -78],
            [35, -70],
            [-31, -93],
            [-29, -19],
            [20, -53],
            [56, -85],
            [10, -59],
            [-1, -50],
            [33, -96],
            [-47, -100],
            [-41, -109],
        ],
        [
            [6125, 2156],
            [-8, 79],
            [26, 82],
            [-28, 62],
            [7, 116],
            [-35, 55],
            [-27, 127],
            [-15, 135],
            [-37, 88],
            [-56, -54],
            [-96, -75],
            [-47, 9],
            [-52, 25],
            [29, 132],
            [-18, 99],
            [-66, 123],
            [10, 38],
            [-49, 14],
            [-60, 86],
        ],
        [
            [5213, 6339],
            [89, 19],
            [161, 91],
            [129, 50],
            [73, -33],
            [88, -1],
            [57, -50],
            [84, -4],
            [122, -26],
            [82, 74],
            [-34, 62],
            [87, 110],
            [95, -44],
            [77, -12],
            [99, -27],
            [16, -80],
            [120, -45],
            [80, 20],
            [107, 14],
            [85, -14],
            [82, -51],
            [52, -54],
            [78, 1],
            [106, -18],
            [78, 27],
            [111, 17],
            [124, 75],
            [51, -11],
            [44, -36],
            [101, 9],
        ],
        [
            [8476, 1995],
            [8, -71],
            [5, -59],
            [-28, -97],
            [-31, 108],
            [-40, -54],
            [27, -78],
            [-24, -50],
            [-99, 62],
            [-24, 76],
            [26, 51],
            [-54, 50],
            [-26, -44],
            [-40, 4],
            [-63, -59],
            [-14, 31],
            [34, 90],
            [53, 30],
            [46, 40],
            [30, -49],
            [64, 30],
            [14, 47],
            [59, 3],
            [-5, 82],
            [69, -50],
            [7, -54],
            [6, -39],
        ],
        [
            [8274, 2193],
            [-31, -35],
            [-26, -67],
            [-27, -31],
            [-52, 73],
            [18, 28],
            [21, 30],
            [9, 66],
            [47, 6],
            [-14, -71],
            [63, 102],
            [-8, -101],
        ],
        [
            [7811, 2091],
            [-113, -101],
            [42, 74],
            [61, 66],
            [51, 73],
            [44, 106],
            [15, -87],
            [-56, -58],
            [-44, -73],
        ],
        [
            [8096, 2364],
            [51, -32],
            [54, 0],
            [-2, -45],
            [-39, -45],
            [-54, -32],
            [-3, 50],
            [6, 54],
            [-13, 50],
        ],
        [
            [8402, 2393],
            [24, -118],
            [-65, 28],
            [1, -36],
            [21, -65],
            [-40, -24],
            [-4, 74],
            [-25, 6],
            [-13, 64],
            [49, -8],
            [-1, 40],
            [-51, 81],
            [81, -2],
            [23, -40],
        ],
        [
            [8066, 2490],
            [-22, -92],
            [-36, 53],
            [-43, 81],
            [72, -4],
            [29, -38],
        ],
        [
            [8049, 3067],
            [52, -30],
            [26, 27],
            [8, -27],
            [-14, -44],
            [29, -76],
            [-23, -88],
            [-49, -35],
            [-14, -86],
            [19, -85],
            [45, -11],
            [37, 12],
            [106, -59],
            [-8, -58],
            [27, -25],
            [-8, -49],
            [-66, 52],
            [-31, 56],
            [-22, -39],
            [-54, 64],
            [-77, -16],
            [-42, 23],
            [5, 44],
            [26, 27],
            [-25, 25],
            [-11, -38],
            [-42, 61],
            [-12, 46],
            [-4, 102],
            [34, -35],
            [9, 166],
            [28, 96],
            [51, 0],
        ],
        [
            [2564, 3749],
            [38, -72],
            [47, -39],
            [62, -14],
            [50, -19],
            [38, -61],
            [23, -35],
            [30, -14],
            [0, -23],
            [-31, -64],
            [-13, -30],
            [-36, -34],
            [-31, -72],
            [-38, 5],
            [-18, -25],
            [-14, -54],
            [11, -71],
            [-8, -13],
            [-39, 0],
            [-53, -39],
            [-8, -52],
            [-19, -23],
            [-53, 1],
            [-33, -27],
            [0, -43],
            [-40, -29],
            [-47, 10],
            [-57, -36],
            [-39, -6],
        ],
        [
            [2286, 2870],
            [-27, 74],
            [-66, 176],
        ],
        [
            [2193, 3120],
            [253, 106],
            [56, 213],
            [-38, 75],
        ],
        [
            [2537, 3869],
            [24, 37],
            [11, -10],
            [-8, -43],
            [-11, -20],
        ],
        [
            [2193, 3120],
            [-244, -41],
            [-79, -48],
            [-60, -111],
            [-40, -18],
            [-21, 35],
            [-32, -5],
            [-82, 11],
            [-15, 10],
            [-98, -2],
            [-23, -10],
            [-34, 28],
            [-23, -52],
            [9, -45],
            [-37, -34],
        ],
        [
            [1414, 2838],
            [-11, 45],
            [-26, 32],
            [-6, 43],
            [-44, 38],
            [-45, 89],
            [-24, 86],
            [-58, 74],
            [-38, 17],
            [-56, 101],
            [-9, 74],
            [3, 63],
            [-48, 118],
            [-40, 41],
            [-46, 22],
            [-27, 61],
            [4, 24],
            [-23, 55],
            [-25, 24],
            [-33, 79],
            [-51, 86],
            [-43, 73],
            [-42, -1],
            [13, 59],
            [3, 37],
            [11, 42],
        ],
        [
            [1890, 4135],
            [33, -92],
            [42, -24],
            [14, -37],
            [58, -45],
            [5, -44],
            [-9, -35],
            [11, -36],
            [24, -30],
            [12, -35],
            [12, -26],
        ],
        [
            [2092, 3731],
            [26, -21],
            [23, 8],
        ],
        [
            [2141, 3718],
            [16, -41],
        ],
        [
            [841, 4782],
            [-8, 81],
            [21, 44],
        ],
        [
            [854, 4907],
            [22, 23],
            [23, 24],
            [5, 59],
            [27, -21],
            [93, 30],
            [45, -20],
            [70, 0],
            [97, 40],
            [45, -2],
            [97, 17],
        ],
        [
            [3530, 5048],
            [47, 107],
            [-18, 79],
            [-62, 26],
            [22, 47],
            [71, -5],
            [40, 58],
            [27, 69],
            [113, 24],
            [-18, -49],
            [12, -30],
            [35, 3],
        ],
        [
            [2092, 3731],
            [-5, 78],
            [22, 55],
            [23, 12],
            [26, -34],
            [2, -62],
            [-19, -62],
        ],
        [
            [3559, 3618],
            [-62, 27],
            [-25, 77],
            [-65, 80],
            [-156, -20],
            [-137, -1],
            [-119, -15],
        ],
        [
            [2355, 5054],
            [-16, 75],
            [13, 111],
            [-66, 36],
            [21, 73],
            [-56, 6],
            [19, 89],
            [80, -26],
            [74, 34],
            [-62, 64],
            [-24, 61],
            [-68, -27],
            [-8, -78],
            [-27, 69],
        ],
        [
            [2528, 5490],
            [95, 2],
            [-14, 53],
            [73, 37],
            [71, 62],
            [114, -57],
            [9, -84],
            [32, -22],
            [91, 5],
            [29, -20],
            [41, -109],
            [97, -73],
            [55, -51],
            [88, -52],
            [113, -45],
            [-3, -65],
        ],
        [
            [8357, 156],
            [10, 25],
            [73, 24],
            [59, 3],
            [26, 14],
            [32, -13],
            [-31, -29],
            [-88, -47],
            [-71, -30],
        ],
        [
            [6466, 2396],
            [-76, 49],
            [-72, -2],
            [12, 83],
            [-74, -1],
            [-7, -116],
            [-45, -156],
            [-28, -94],
            [6, -76],
            [55, -4],
            [34, -97],
            [15, -92],
            [48, -61],
            [51, -12],
            [44, -55],
        ],
        [
            [6255, 1788],
            [-33, 41],
            [-15, 52],
            [-45, 60],
            [-41, 51],
            [-14, -63],
            [-16, 59],
            [10, 66],
            [24, 102],
        ],
        [
            [854, 4907],
            [-31, 48],
            [32, 40],
            [-52, -9],
            [-70, 25],
            [-59, -61],
            [-128, -12],
            [-68, 57],
            [-91, 3],
            [-20, -44],
            [-58, -13],
            [-82, 57],
            [-92, -2],
            [-50, 106],
            [-62, 59],
            [41, 82],
            [-53, 51],
            [93, 102],
            [131, 4],
            [35, 81],
            [161, -14],
            [102, 69],
            [98, 30],
            [140, 2],
            [147, -75],
            [121, -41],
            [99, 16],
            [73, -9],
            [99, 55],
        ],
        [
            [97, 5425],
            [-70, -58],
            [-27, 50],
            [1, 22],
            [20, 12],
            [26, 66],
            [-41, 28],
            [86, 34],
            [73, -15],
            [10, -40],
            [74, -35],
            [-16, -26],
            [-100, -6],
            [-36, -32],
        ],
        [
            [8087, 3693],
            [-50, -170],
            [-37, -88],
            [-44, 90],
            [-10, 79],
            [50, 104],
            [67, 81],
            [39, -32],
            [-15, -64],
        ],
        [
            [6928, 3391],
            [-113, -91],
            [-70, -100],
            [-19, -74],
            [65, -112],
            [79, -139],
            [76, -66],
            [52, -85],
            [38, -197],
            [-11, -186],
            [-71, -70],
            [-96, -69],
            [-69, -88],
            [-106, -99],
            [-30, 68],
            [23, 72],
            [-62, 60],
        ],
        [
            [2286, 2870],
            [-61, -28],
            [-16, -48],
            [-2, -36],
            [-84, -45],
            [-135, -49],
            [-76, -75],
            [-37, -6],
            [-25, 6],
            [-50, -44],
            [-54, -20],
            [-70, -6],
            [-22, -6],
            [-18, -28],
            [-22, -8],
            [-13, -27],
            [-42, 3],
            [-27, -15],
            [-59, 6],
            [-22, 62],
            [3, 58],
            [-14, 31],
            [-17, 79],
            [-24, 43],
            [17, 6],
            [-9, 48],
            [11, 21],
            [-4, 46],
        ],
        [
            [8836, 5606],
            [12, -19],
            [-32, 6],
            [-37, -36],
            [-25, -36],
            [3, -76],
            [-44, -23],
            [-15, -19],
            [-31, -32],
            [-57, -17],
            [-36, -29],
            [-3, -46],
            [-10, -11],
            [34, -18],
            [48, -46],
        ],
        [
            [8459, 5112],
            [-41, 20],
            [-10, -20],
            [-25, -8],
            [-3, 19],
            [-22, 10],
            [-23, 17],
            [23, 47],
            [20, 12],
            [-7, 20],
            [21, 57],
            [-5, 18],
            [-50, 11],
            [-39, 29],
        ],
    ],
    transform: {
        scale: [0.011837522136753863, 0.009410998801956985],
        translate: [26.043351271272545, -10.359987481327963],
    },
    objects: {
        countries: {
            type: 'GeometryCollection',
            geometries: [
                {
                    arcs: [[0, 1, 2, 3, 4]],
                    type: 'Polygon',
                    properties: {
                        name: 'Armenia',
                        country: 'AM',
                    },
                },
                {
                    arcs: [[[-4, 5]], [[-2, 6, 7, 8]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Azerbaijan',
                        country: 'AZ',
                    },
                },
                {
                    arcs: [[9, 10, 11, 12, 13, 14]],
                    type: 'Polygon',
                    properties: {
                        name: 'Afghanistan',
                        country: 'AF',
                    },
                },
                {
                    arcs: [[15, 16, 17, 18, 19]],
                    type: 'Polygon',
                    properties: {
                        name: 'United Arab Emirates',
                        country: 'AE',
                    },
                },
                {
                    arcs: [
                        [[20]],
                        [[-13, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37]],
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        type: 'Country',
                        name: 'China',
                        country: 'CN',
                    },
                },
                {
                    arcs: [[38, 39, 40]],
                    type: 'Polygon',
                    properties: {
                        name: 'Bangladesh',
                        country: 'BD',
                    },
                },
                {
                    arcs: [[41, 42]],
                    type: 'Polygon',
                    properties: {
                        name: 'Brunei',
                        country: 'BN',
                    },
                },
                {
                    arcs: [[-34, 43]],
                    type: 'Polygon',
                    properties: {
                        name: 'Bhutan',
                        country: 'BT',
                    },
                },
                {
                    arcs: [[44, 45]],
                    type: 'Polygon',
                    properties: {
                        name: 'Cyprus',
                        country: 'CY',
                    },
                },
                {
                    arcs: [[-46, 46]],
                    type: 'Polygon',
                    properties: {
                        name: 'N. Cyprus',
                        country: 'CY',
                    },
                },
                {
                    arcs: [[-1, 47, 48, -7]],
                    type: 'Polygon',
                    properties: {
                        name: 'Georgia',
                        country: 'GE',
                    },
                },
                {
                    arcs: [
                        [[49]],
                        [[50, 51]],
                        [[52]],
                        [[53]],
                        [[54]],
                        [[55]],
                        [[56]],
                        [[57]],
                        [[58]],
                        [[59]],
                        [[60]],
                        [[61, 62]],
                        [[63]],
                    ],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Indonesia',
                        country: 'ID',
                    },
                },
                {
                    arcs: [[-33, 64, -41, 65, 66, -37, 67, -35, -44]],
                    type: 'Polygon',
                    properties: {
                        name: 'India',
                        country: 'IN',
                    },
                },
                {
                    arcs: [[68, 69, 70, 71, 72, 73, 74, 75]],
                    type: 'Polygon',
                    properties: {
                        name: 'Iraq',
                        country: 'IQ',
                    },
                },
                {
                    arcs: [[76, 77, 78, 79, 80, 81]],
                    type: 'Polygon',
                    properties: {
                        name: 'Israel',
                        country: 'IL',
                    },
                },
                {
                    arcs: [[-3, -9, 82, 83, -15, 84, 85, -69, -76, 86, -6]],
                    type: 'Polygon',
                    properties: {
                        name: 'Iran',
                        country: 'IR',
                    },
                },
                {
                    arcs: [[[87]], [[88]], [[89]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Japan',
                        country: 'JP',
                    },
                },
                {
                    arcs: [[-73, 90, 91, -79, 92, -77, 93]],
                    type: 'Polygon',
                    properties: {
                        name: 'Jordan',
                        country: 'JO',
                    },
                },
                {
                    arcs: [[-23, 94, 95, 96]],
                    type: 'Polygon',
                    properties: {
                        name: 'Kyrgyzstan',
                        country: 'KG',
                    },
                },
                {
                    arcs: [[-24, -97, 97, 98, 99]],
                    type: 'Polygon',
                    properties: {
                        name: 'Kazakhstan',
                        country: 'KZ',
                    },
                },
                {
                    arcs: [[100, 101, 102, 103]],
                    type: 'Polygon',
                    properties: {
                        name: 'Cambodia',
                        country: 'KH',
                    },
                },
                {
                    arcs: [[-71, 104, 105]],
                    type: 'Polygon',
                    properties: {
                        name: 'Kuwait',
                        country: 'KW',
                    },
                },
                {
                    arcs: [[106, 107]],
                    type: 'Polygon',
                    properties: {
                        name: 'Korea',
                        country: 'KR',
                    },
                },
                {
                    arcs: [[-31, 108, -102, 109, 110]],
                    type: 'Polygon',
                    properties: {
                        name: 'Lao PDR',
                        country: 'LA',
                    },
                },
                {
                    arcs: [[-81, 111, 112]],
                    type: 'Polygon',
                    properties: {
                        name: 'Lebanon',
                        country: 'LB',
                    },
                },
                {
                    arcs: [[113]],
                    type: 'Polygon',
                    properties: {
                        name: 'Sri Lanka',
                        country: 'LK',
                    },
                },
                {
                    arcs: [[[114, 115]], [[-43, 116, -62, 117]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Malaysia',
                        country: 'MY',
                    },
                },
                {
                    arcs: [[-32, -111, 118, 119, -39, -65]],
                    type: 'Polygon',
                    properties: {
                        name: 'Myanmar',
                        country: 'MM',
                    },
                },
                {
                    arcs: [[-36, -68]],
                    type: 'Polygon',
                    properties: {
                        name: 'Nepal',
                        country: 'NP',
                    },
                },
                {
                    arcs: [[-26, 120]],
                    type: 'Polygon',
                    properties: {
                        name: 'Mongolia',
                        country: 'MN',
                    },
                },
                {
                    arcs: [[[121]], [[122]], [[123]], [[124]], [[125]], [[126]], [[127]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Philippines',
                        country: 'PH',
                    },
                },
                {
                    arcs: [[[-19, 128, 129, 130]], [[-17, 131]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Oman',
                        country: 'OM',
                    },
                },
                {
                    arcs: [[-78, -93]],
                    type: 'Polygon',
                    properties: {
                        type: 'Disputed',
                        name: 'Palestine',
                        country: 'PS',
                    },
                },
                {
                    arcs: [[-20, -131, 132, 133, -91, -72, -106, 134, 135, 136]],
                    type: 'Polygon',
                    properties: {
                        name: 'Saudi Arabia',
                        country: 'SA',
                    },
                },
                {
                    arcs: [[-74, -94, -82, -113, 137, 138]],
                    type: 'Polygon',
                    properties: {
                        name: 'Syria',
                        country: 'SY',
                    },
                },
                {
                    arcs: [[-12, 139, -95, -22]],
                    type: 'Polygon',
                    properties: {
                        name: 'Tajikistan',
                        country: 'TJ',
                    },
                },
                {
                    arcs: [[-136, 140]],
                    type: 'Polygon',
                    properties: {
                        name: 'Qatar',
                        country: 'QA',
                    },
                },
                {
                    arcs: [[-14, -38, -67, 141, -85]],
                    type: 'Polygon',
                    properties: {
                        name: 'Pakistan',
                        country: 'PK',
                    },
                },
                {
                    arcs: [[-10, -84, 142, -99, 143]],
                    type: 'Polygon',
                    properties: {
                        name: 'Turkmenistan',
                        country: 'TM',
                    },
                },
                {
                    arcs: [[-51, 144]],
                    type: 'Polygon',
                    properties: {
                        name: 'Timor-Leste',
                        country: 'TL',
                    },
                },
                {
                    arcs: [[-101, 145, -116, 146, -119, -110]],
                    type: 'Polygon',
                    properties: {
                        name: 'Thailand',
                        country: 'TH',
                    },
                },
                {
                    arcs: [[[-5, -87, -75, -139, 147, -48]], [[148]]],
                    type: 'MultiPolygon',
                    properties: {
                        name: 'Turkey',
                        country: 'TR',
                    },
                },
                {
                    arcs: [[149]],
                    type: 'Polygon',
                    properties: {
                        name: 'Taiwan',
                        country: 'TW',
                    },
                },
                {
                    arcs: [[-30, 150, -103, -109]],
                    type: 'Polygon',
                    properties: {
                        name: 'Vietnam',
                        country: 'VN',
                    },
                },
                {
                    arcs: [[-11, -144, -98, -96, -140]],
                    type: 'Polygon',
                    properties: {
                        name: 'Uzbekistan',
                        country: 'UZ',
                    },
                },
                {
                    arcs: [[-130, 151, -133]],
                    type: 'Polygon',
                    properties: {
                        name: 'Yemen',
                        country: 'YE',
                    },
                },
                {
                    arcs: [[-28, 152, -108, 153]],
                    type: 'Polygon',
                    properties: {
                        name: 'Dem. Rep. Korea',
                        country: 'KP',
                    },
                },
            ],
        },
    },
};

export default data;
